<template>
  <date-time-picker
    v-model="value"
    outlined
    :label="label"
  />
</template>

<script>
  import DateTimePicker from './../UIComponents/DateTimePicker'
  export default {
    components: {
      DateTimePicker,
    },
    data () {
      return {
        value: '',
        label: 'Max value',
      }
    },
  }
</script>

<style scoped>

</style>
